// Volume-based COGS curve for the remembr bundle ($180 ASP, 15") and software ($120 ASP).
// Bundle hardware cost (tablet + headphones + branded box + freight + drop-ship) drops as MOQ rises.
// Software-only is essentially flat (cloud + payment processing).
//
// Tiers are reproduced 1:1 in backend/pdf_export.py — keep both sides in sync.

export const COGS_TIERS = [
    // [min_units_inclusive, label, bundle_hardware_cogs_usd, bundle_other_costs_usd]
    { min: 1_000_000, label: "1M+", bundleHardware: 52, bundleOther: 13 },   // 150 - 65 = $85 net
    { min: 250_000,   label: "250K+", bundleHardware: 64, bundleOther: 13 }, // 150 - 77 = $73 net
    { min: 50_000,    label: "50K+",  bundleHardware: 78, bundleOther: 13 }, // 150 - 91 = $59 net
    { min: 10_000,    label: "10K+",  bundleHardware: 98, bundleOther: 13 }, // 150 - 111 = $39 net
    { min: 1_000,     label: "1K+",   bundleHardware: 118, bundleOther: 13 },// 150 - 131 = $19 net
    { min: 0,         label: "Pilot", bundleHardware: 135, bundleOther: 13 },// 150 - 148 = $2 net
];

export const SOFTWARE_NET_USD = 110; // $120 ASP - ~$5 cloud/TTS amortised - ~$5 payment processing

export function tierForUnits(units) {
    return COGS_TIERS.find((t) => units >= t.min) || COGS_TIERS[COGS_TIERS.length - 1];
}

// Blended net-per-unit for a given annual volume + bundle/software mix.
//   units   — that year's total unit volume (bundle + software combined)
//   blend   — 0..100, % of units that are bundle SKU
//   asps    — { bundle: 180, software: 120 }
// Returns: { net_per_unit_usd, bundle_net_usd, tier }
export function blendedNetForVolume(units, blend, asps = { bundle: 180, software: 120 }) {
    // Volume tier is keyed off the HARDWARE share since that's what drives factory MOQ.
    const bundleUnits = Math.round(units * (blend / 100));
    const tier = tierForUnits(bundleUnits);
    const bundleNet = Math.max(0, asps.bundle - tier.bundleHardware - tier.bundleOther);
    const softwareNet = SOFTWARE_NET_USD;
    const blended = (blend / 100) * bundleNet + (1 - blend / 100) * softwareNet;
    return { net_per_unit_usd: blended, bundle_net_usd: bundleNet, software_net_usd: softwareNet, tier };
}
